export default "__VITE_ASSET__CejORFfV__"